import { alpha, Box, FormLabel, Stack } from '@mui/material';
import ComponentIcon from 'app/app/editor/tabs/components/ComponentIcon';
import { useAppBuilderContext } from 'app/app/editor/context';
import React, { useState } from 'react';
import CheckBoxSearch from 'components/common/check-box-list/CheckBoxSearch';
import useBundleTranslation from 'i18n';

import preview_container from './preview/container.png';
import preview_text from './preview/text.png';
import preview_image from './preview/image.png';
import preview_filter from './preview/filter.png';
import { IMenuComponent } from 'app/app/editor/tabs/components/index';

// TODO: Replace CheckBoxSearch with custom 'Search' or Replace\Rename 'CheckBoxSearch' to become a generic component for search?
function Search(props: { onChange: (event: any) => void; value: string; placeholder?: string }) {
    return <CheckBoxSearch {...props} />;
}

export default function ComponentsTab() {
    const { t } = useBundleTranslation(['app/portal-page-builder']);
    const ctx = useAppBuilderContext();
    const [search, setSearch] = useState('');
    const [previewComponentType, setPreviewComponentType] = useState('');

    const alias_preview: any = {
        container: preview_container,
        text: preview_text,
        image: preview_image,
        filter: preview_filter,
    };

    const getName = (c: IMenuComponent) => {
        return c.title ?? t(`components_list.component_label.${c.name}`);
    };

    return (
        <Stack sx={{ py: 2, height: 1 }}>
            <Box sx={{ px: 2 }}>
                <Search value={search} onChange={(v?: string) => setSearch(v?.toLowerCase() ?? '')} />
            </Box>
            <Box sx={{ px: 2, flexGrow: 1, overflow: 'auto' }}>
                {ctx.componentsMenu
                    .filter(
                        (section) =>
                            section.components.filter((c) =>
                                t(`components_list.component_label.${c.name}`).toLowerCase().includes(search),
                            ).length != 0,
                    )
                    .map((s) => {
                        return (
                            <Box key={s.name} sx={{ pt: 2 }}>
                                <Box sx={{ fontWeight: 600, py: 0.5, mb: 0.5 }}>
                                    {s?.title ?? t(`components_list.section_heading.${s.name}`)}
                                </Box>
                                <Stack direction={'column'} spacing={0.5}>
                                    {s.components
                                        .filter((c) => getName(c).toLowerCase().includes(search))
                                        .map((c) => (
                                            <ComponentIcon
                                                type={c.name}
                                                key={c.name}
                                                icon={c.icon}
                                                setPreviewComponentType={setPreviewComponentType}
                                                title={getName(c)}
                                            />
                                        ))}
                                </Stack>
                            </Box>
                        );
                    })}
            </Box>
            <Stack
                direction={'row'}
                sx={{
                    p: 2,
                    height: '193px',
                    borderTop: (theme) => `1px solid ${alpha(theme.palette.text.primary, 0.08)}`,
                    justifyContent: 'center',
                    alignItems: 'center',
                    flexShrink: 0,
                }}
            >
                {previewComponentType == '' ? (
                    <Box sx={{ color: (theme) => alpha(theme.palette.text.primary, 0.4) }}>
                        {t(`components_list.preview_placeholder`)}
                    </Box>
                ) : (
                    <Box
                        component={'img'}
                        src={alias_preview[previewComponentType]}
                        sx={{ maxWidth: '100%', maxHeight: '100%' }}
                    />
                )}
            </Stack>
        </Stack>
    );
}
